import React from 'react'

interface RemovableChipProps {
  label: string
  onRemove: () => void
  // `outline` reads clearly on a grey field, `filled` on a white surface.
  variant?: 'filled' | 'outline'
  disabled?: boolean
}

const RemovableChip = ({ label, onRemove, variant = 'filled', disabled = false }: RemovableChipProps) => (
  <span className={`status-badge status-badge--neutral-${variant} removable-chip`}>
    <span className="removable-chip__label">{label}</span>
    <button
      type="button"
      className="removable-chip__remove ms-2"
      aria-label={`Remove ${label}`}
      title={`Remove ${label}`}
      disabled={disabled}
      onClick={onRemove}
    >
      ×
    </button>
  </span>
)

export default RemovableChip
